<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('bulletList')
})

const onToggleBulletList = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleBulletList().run()
}
</script>

<template>
    <button
        @click="onToggleBulletList"
        :class="
            clsx(
                'action-bullet-list',
                isActive ? 'is-active' : 'is-deactive',
                isDark ? 'dark' : 'light'
            )
        "
        :disabled="!editor.can().chain().focus().toggleBulletList().run()"
    >
        <span class="sr-only">Bullet List</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M9.55111 6H21M9.55111 11.9941H21M9.55111 17.9882H21M5 6V6.01184M5 11.9941V12.0059M5 17.9882V18"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-bullet-list.light svg {
    @apply stroke-[#060606];
}

.action-bullet-list.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-bullet-list.is-deactive svg {
    @apply opacity-60;
}

.action-bullet-list.is-active svg {
    @apply opacity-100;
}
</style>
